module.exports = __webpack_public_path__ + "img/ring_y_o_null_0.b761b52c.png";